import css from 'styled-jsx/css';

const styles = css.global`:root {
  --text-field-main-color: #444;
  --text-field-light-color: #727272;
  --text-field-text-color: #444;
  --text-field-error-color: #f14c4c;
}

.text-field {
  position: relative;
  display: inline-flex;
  flex-direction: column;
  min-width: 0;
  width: 100%;
  vertical-align: top;
  font-family: 'SantanderText';
}

.text-field__container {
  position: relative;
  border-radius: 4px;
}

.text-field__input {
  font-size: 18px;
  font-family: inherit;
  font-weight: 400;
  line-height: 1.1;
  color: var(--text-field-text-color);
  width: 100%;
  padding: 9px 16px;
  border: none;
  outline: none;
  background: transparent;
  position: relative;
  z-index: 1;
  min-height: 46px;
  box-sizing: border-box;
  height: 100%;
}

.text-field__label {
  position: absolute;
  left: 0;
  top: 0;
  color: var(--text-field-main-color);
  font-size: 18px;
  font-family: inherit;
  font-weight: 400;
  line-height: 1.1;
  transform: translate(14px, 14px) scale(1);
  transform-origin: top left;
  transition:
    color 200ms cubic-bezier(0, 0, 0.2, 1) 0ms,
    transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms,
    max-width 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  max-width: calc(100% - 28px);
  overflow: visible;

  pointer-events: none;
  z-index: 2;
}

.text-field__label.hide-label-overflow {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.text-field__label.floating {
  transform: translate(16px, -8px) scale(0.75);
  max-width: calc(133% - 32px);
}

.text-field.focused .text-field__label {
  color: var(--text-field-main-color);
}

.text-field.disabled .text-field__label {
  color: var(--text-field-main-color);
}

.text-field__fieldset {
  position: absolute;
  inset: -5px 0 0;
  margin: 0;
  padding: 0 12px;
  border-radius: 4px;
  border-style: solid;
  border-width: 1px;
  border-color: var(--text-field-light-color);
  pointer-events: none;
  overflow: hidden;
  transition:
    border-color 200ms cubic-bezier(0, 0, 0.2, 1) 0ms,
    border-width 150ms cubic-bezier(0, 0, 0.2, 1) 0ms;

  z-index: 2;
  background: transparent;
}

.text-field.focused .text-field__fieldset {
  border-color: var(--text-field-light-color);
  border-width: 1px;
}

.text-field__fieldset:hover {
  border-color: var(--text-field-light-color);
}

.text-field.focused .text-field__fieldset:hover {
  border-color: var(--text-field-light-color);
}

.text-field__legend {
  display: block;
  float: unset;
  width: auto;
  padding: 0;
  /* this is because the label is scaled at 0.75 */
  font-size: 0.75em;
  line-height: 1.1;
  visibility: hidden;
  max-width: 0.01px;
  white-space: nowrap;
  overflow: hidden;
  transition: max-width 50ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  color: var(--text-field-main-color);
  letter-spacing: 0.045em;
  font-family: 'SantanderText';
}

.text-field__legend.visible {
  max-width: 100%;
  transition: max-width 100ms cubic-bezier(0, 0, 0.2, 1) 50ms;
}

.text-field__legend > span {
  display: inline-block;
  padding: 0 4px;
  visibility: visible;
  opacity: 0;
}

.text-field__helper {
  font-family: 'SantanderMicroText';
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0%;
  vertical-align: middle;
  margin: 4px 0 0;
  color: var(--text-field-light-color);
}

.text-field.error .text-field__input,
.text-field.error .text-field__fieldset,
.text-field.error .text-field__label,
.text-field__helper.error {
  color: var(--text-field-error-color);
}

.text-field.error .text-field__fieldset {
  border-color: var(--text-field-error-color);
}

.text-field.disabled .text-field__input {
  cursor: default;
}

.text-field.disabled {
  opacity: 0.36;
}

.text-field__suggestions {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: #fff;
  border: none;
  z-index: 5;
  box-shadow: 0px 2px 8px -2px #2222221f;
  border-radius: 6px;

  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  height: auto;
  padding: 0 16px 8px;

  max-height: calc(4 * 45px);
  overflow: auto;
}

.text-field__suggestions .suggestion {
  box-sizing: border-box;
  padding: 8px 0;
  border-bottom: 1px solid #cccccc;
  cursor: pointer;
  height: 45px;
}

.text-field__suggestions .suggestion:last-of-type {
  border-bottom: none !important;
}

.text-field__suggestions .suggestion p {
  font-family: 'SantanderText';
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0%;
  vertical-align: middle;
}

.text-field__end-adornment {
  pointer-events: none;
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.text-field__start-adornment {
  pointer-events: none;
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.text-field.has-start-adornment .text-field__input {
  padding-left: 46px;
}

.text-field.has-end-adornment .text-field__input {
  padding-right: 46px;
}

.text-field.has-start-adornment .text-field__label {
  transform: translate(46px, 14px) scale(1);
}

.text-field.has-start-adornment .text-field__label.floating {
  transform: translate(14px, -9px) scale(0.75);
}

.text-field.show-money-sign .text-field__input {
  padding-left: 40px;
}

.text-field.show-money-sign.is-money .text-field__input {
  padding-left: 48px;
}

.text-field .money-adornment {
  display: none;
}

.text-field.show-money-sign .money-adornment {
  pointer-events: none;
  position: absolute;
  left: 16px;
  top: 22px;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;

  font-family: 'SantanderText';
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0%;
  color: #222222;
}

.text-field.is-money.show-money-sign .money-adornment {
  top: 23px;

  font-family: 'SantanderText';
  font-weight: 700;
  font-size: 24px;
  line-height: 1.1;
}

.text-field__input:-webkit-autofill,
.text-field__input:-webkit-autofill:hover,
.text-field__input:-webkit-autofill:focus,
.text-field__input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px white inset;
  -webkit-text-fill-color: var(--text-field-text-color);
}

.text-field.is-money .text-field__input {
  font-family: SantanderText;
  font-weight: 700;
  font-size: 24px;
  line-height: 1.1;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #222;
  max-height: 46px;
}

.text-field.error.is-money .text-field__input,
.text-field.error.show-money-sign .money-adornment {
  color: var(--text-field-error-color);
}

.text-field__end-adornment.interactive {
  pointer-events: all;
  cursor: pointer;
  z-index: 2;
}

.text-field.hide-label .text-field__legend,
.text-field.hide-label .text-field__label {
  display: none !important;
}

.text-field.hide-label .text-field__fieldset {
  inset: 0;
}
`;

export default styles;